const NEWSLETTER_GATE_STORAGE_KEY = 'newsletter_gate_subscribed';

class NewsletterGate {
  static canBypass() {
    if (!window.newsletterGate?.enabled) return true;
    if (window.newsletterGate.loggedIn) return true;
    try {
      return localStorage.getItem(NEWSLETTER_GATE_STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  }

  static markSubscribed() {
    try {
      localStorage.setItem(NEWSLETTER_GATE_STORAGE_KEY, '1');
    } catch {
      /* ignore */
    }
  }

  static require(callback, opener) {
    if (this.canBypass()) {
      callback();
      return;
    }

    this._pendingCallback = callback;
    const modal = document.getElementById('NewsletterGateModal');
    if (modal) {
      modal.show(opener);
    } else {
      callback();
    }
  }

  static completeAndProceed() {
    this.markSubscribed();
    const callback = this._pendingCallback;
    this._pendingCallback = null;
    const modal = document.getElementById('NewsletterGateModal');
    if (modal) modal.hide(true);
    if (callback) {
      setTimeout(callback, 0);
    }
  }

  static cancel() {
    this._pendingCallback = null;
  }
}

window.NewsletterGate = NewsletterGate;

function isAddToCartTrigger(button) {
  if (!button) return false;
  return (
    button.matches('.quick-add__submit') ||
    button.matches('.lyh_index_btn') ||
    (button.getAttribute('name') === 'add' && button.closest('modal-opener, product-form, form[data-type="add-to-cart-form"]'))
  );
}

function initAddToCartGate() {
  document.addEventListener(
    'click',
    (event) => {
      if (NewsletterGate.canBypass()) return;

      const button = event.target.closest('button');
      if (!isAddToCartTrigger(button)) return;

      const modalOpener = button.closest('modal-opener');
      if (modalOpener) {
        const modalSelector = modalOpener.getAttribute('data-modal');
        if (!modalSelector) return;

        event.preventDefault();
        event.stopPropagation();

        NewsletterGate.require(() => {
          const modal = document.querySelector(modalSelector);
          if (modal) modal.show(button);
        }, button);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      if (NewsletterGate.canBypass()) return;

      const form = event.target;
      if (!form.matches('form.b_car')) return;
      if (form.dataset.newsletterGateBypass === 'true') return;

      event.preventDefault();
      event.stopPropagation();

      NewsletterGate.require(() => {
        form.dataset.newsletterGateBypass = 'true';
        form.requestSubmit();
      }, form.querySelector('[type="submit"]'));
    },
    true
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAddToCartGate);
} else {
  initAddToCartGate();
}

if (!customElements.get('newsletter-gate-modal')) {
  customElements.define(
    'newsletter-gate-modal',
    class NewsletterGateModal extends ModalDialog {
      constructor() {
        super();
        this.onFormSubmit = this.onSubmit.bind(this);
      }

      connectedCallback() {
        super.connectedCallback();
        if (this._gateInitialized) return;
        this._gateInitialized = true;

        this.form = this.querySelector('#NewsletterGateForm');
        this.errorEl = this.querySelector('#NewsletterGateError');
        this.errorTextEl = this.querySelector('.newsletter-gate-modal__error-text');
        this.submitButton = this.querySelector('.newsletter-gate-modal__submit');
        this.successEl = this.querySelector('#NewsletterGateSuccess');

        if (this.form) {
          this.form.addEventListener('submit', this.onFormSubmit);
          this.wireCaptcha(this.form);
        }
      }

      show(opener) {
        super.show(opener);
        if (this.form) {
          this.wireCaptcha(this.form);
          this.form.querySelector('[name="contact[email]"]')?.focus();
        }
      }

      wireCaptcha(form) {
        if (window.Shopify?.captcha?.protect) {
          window.Shopify.captcha.protect(form);
        }
      }

      hide(skipCancel = false) {
        if (!skipCancel) NewsletterGate.cancel();
        super.hide();
      }

      onSubmit(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.submitButton?.classList.contains('loading')) return;

        const emailInput = this.form.querySelector('[name="contact[email]"]');
        const email = emailInput?.value?.trim();

        if (!email) {
          this.showError(window.newsletterGate?.strings?.emailRequired || 'Please enter your email.');
          emailInput?.focus();
          return;
        }

        this.hideError();
        this.hideSuccess();
        this.submitButton.classList.add('loading');
        this.submitButton.setAttribute('aria-disabled', 'true');

        const submitWithCaptcha = () => this.submitViaIframe();

        if (window.Shopify?.captcha?.protect) {
          window.Shopify.captcha.protect(this.form, submitWithCaptcha);
        } else {
          submitWithCaptcha();
        }
      }

      submitViaIframe() {
        let iframe = document.getElementById('NewsletterGateIframe');
        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.id = 'NewsletterGateIframe';
          iframe.name = 'NewsletterGateIframe';
          iframe.setAttribute('aria-hidden', 'true');
          iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
          document.body.appendChild(iframe);
        }

        const handleLoad = () => {
          iframe.removeEventListener('load', handleLoad);
          this.form.removeAttribute('target');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');

          try {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
            if (!iframeDoc) throw new Error('iframe unavailable');

            const html = iframeDoc.documentElement.innerHTML;
            const url = iframe.contentWindow.location.href;
            const shopifyError = this.extractShopifyError(iframeDoc);

            if (shopifyError) {
              this.showError(shopifyError);
              return;
            }

            if (this.isSubscriptionSuccess(html, url)) {
              this.showSuccess();
              setTimeout(() => NewsletterGate.completeAndProceed(), 600);
              return;
            }

            this.showError(
              window.newsletterGate?.strings?.error ||
                'Unable to subscribe with this email. Please try again.'
            );
          } catch {
            this.showSuccess();
            setTimeout(() => NewsletterGate.completeAndProceed(), 600);
          }
        };

        iframe.addEventListener('load', handleLoad);
        this.form.target = 'NewsletterGateIframe';
        HTMLFormElement.prototype.submit.call(this.form);
      }

      extractShopifyError(doc) {
        const gateForm = doc.querySelector('#NewsletterGateForm');
        if (!gateForm) return null;

        const errorEl = gateForm.querySelector('.form__message.errors, .errors');
        const message = errorEl?.textContent?.replace(/\s+/g, ' ').trim();
        return message || null;
      }

      isSubscriptionSuccess(html, url) {
        const successText = window.newsletterGate?.strings?.success || 'Thanks for subscribing';

        if (html.includes('already been taken') || html.includes('has already been taken')) {
          return true;
        }

        if (
          url.includes('customer_posted=true') ||
          url.includes('contact_posted=true') ||
          url.includes('newsletter_gate=success')
        ) {
          return true;
        }

        return (
          html.includes('newsletter-form__message--success') ||
          html.includes(successText) ||
          html.includes('form-status-list form__message')
        );
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorTextEl.textContent = message;
        this.errorEl.classList.remove('hidden');
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.classList.add('hidden');
        this.errorTextEl.textContent = '';
      }

      showSuccess() {
        if (!this.successEl) return;
        this.successEl.classList.remove('hidden');
        if (this.form) this.form.classList.add('hidden');
      }

      hideSuccess() {
        if (!this.successEl) return;
        this.successEl.classList.add('hidden');
        if (this.form) this.form.classList.remove('hidden');
      }
    }
  );
}
